module.exports = __webpack_public_path__ + "resources/feature-icon-4-bc171d8e3aadfe543b3bf490e7489ca4.png";


//////////////////
// WEBPACK FOOTER
// ./DeviceNetwork/www/resources/images/feature-icon-4.png
// module id = 80
// module chunks = 0